import { Controller, useFormContext } from 'react-hook-form';
import ServiceAccountingAutocomplete from "../../../integrations/Accounting/ServiceAccountingAutocomplete/ServiceAccountingAutocomplete";
import { jsx as _jsx } from "react/jsx-runtime";
const ServiceAccountingField = _ref => {
  let {
    testid,
    accounting,
    accountingItems,
    isDisabled,
    controlName,
    isBundle
  } = _ref;
  const {
    control
  } = useFormContext();
  return /*#__PURE__*/_jsx(Controller, {
    name: controlName,
    control: control,
    render: _ref2 => {
      let {
        field: {
          value: serviceMapping,
          onChange
        }
      } = _ref2;
      return /*#__PURE__*/_jsx(ServiceAccountingAutocomplete, {
        testid: testid,
        isDisabled: isDisabled,
        accountingItems: accountingItems,
        selectedOption: serviceMapping.type === 'mapped' ? serviceMapping.mappedItem : null,
        showAccountingMapPlaceHolder: true,
        accounting: accounting,
        onItemChange: item => onChange(item ? {
          type: 'mapped',
          mappedItem: item
        } : {
          type: 'unmapped'
        }),
        isBundle: isBundle
      });
    }
  });
};
export default ServiceAccountingField;